<template>
  <div id="app" >
    <router-view/>
  </div>
</template>


<script>


export default {
  components:{
}
}
</script>




<style scoped >
  ::v-deep .v-application--wrap {
    min-height: fit-content;
  }

</style>